import styled from 'styled-components';

import { spaces } from '@gaming1/g1-style';

export const DepositWalletImg = styled.img`
  margin: ${spaces('lg')} ${spaces('sm')} 0;
`;
